import { createSlice } from "@reduxjs/toolkit";
import { AuthInitialState } from "../../types";

const initialState: AuthInitialState = {
  access_token: undefined,
  user: undefined,
  role: undefined,
  // role: "Admin",
  showModalDashboard: true,
  authInfo: {
    id: undefined,
    role: undefined,
    // role: "Admin",
  },
  refresh_token: undefined,
  expires_in: undefined,
  refresh_expires_in: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state, action) => {
      state.access_token = action.payload?.access_token;
      state.user = action.payload?.user;
      state.role = action.payload?.role;
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.user = undefined;
      state.role = undefined;
      // localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    },
    setSuccessSignup: (state, action) => {
      state.isSuccessSignup = action.payload;
    },
    setShowModal: (state, action) => {
      state.showModalDashboard = action.payload;
    },
    setAuthInfo: (state, action) => {
      state.authInfo = {
        ...state.authInfo,
        ...action?.payload,
      };
    },
    setToken(state, action) {
      state.access_token = action.payload?.access_token;
      state.refresh_token = action.payload?.refresh_token;
      state.expires_in = action.payload?.expires_in;
      state.refresh_expires_in = action.payload?.refresh_expires_in;
      localStorage.setItem("kc-token", JSON.stringify(action.payload));
    },
    clearAuth(state) {
      state.access_token = undefined;
      state.refresh_token = undefined;
      state.expires_in = undefined;
      state.refresh_expires_in = undefined;
      localStorage.removeItem("kc-token");
    },
  },
});

export const {
  userLoggedIn,
  userLoggedOut,
  setSuccessSignup,
  setShowModal,
  setAuthInfo,
  setToken,
  clearAuth,
} = authSlice.actions;
export default authSlice.reducer;
